import { Navigate, createBrowserRouter } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import Login from "../pages/onboarding/Login";
import UserManagement from "../pages/user";
import Investment from "../pages/investment";
import InvestmentDetail from "../pages/investment/InvestmentDetail";
import RealEstateInvestmentDetail from "../pages/RealEstate/InvestmentDetail";
import Transaction from "../pages/transaction";
import TransactionDetail from "../pages/transaction/TransactionDetail";
import AllTransaction from "../pages/transaction/AllTransaction";
import CreateCampaign from "../pages/investment/CreateCampaign";
import EditInvestment from "../pages/investment/EditInvestment";
import PreviousRecords from "../pages/previousRecords";
import WithdrawalRequest from "../pages/withdrawal";
import UserManagementDetail from "../pages/user/UserManagementDetail";
import AccountSummary from "../pages/accountSummary'";
import AccountSummaryDetail from "../pages/accountSummary'/AccountSummaryDetail";
import DraftEmail from "../pages/AdminEmail/Index";
import ChartOfAccount from "../pages/ChartOfAccount/ChartOfAccount";
import AdminEmail from "../pages/AdminEmail/Index";
import ProvidusReport from "../pages/providusReport";
import ProvidusReportDetail from "../components/dashboard/providusReport/ProvidusReportDetail";
import WaitList from "../pages/waitlist";
import BusinessUserManagementDetail from "../pages/user/BusinessUserManagementDetail";
import Application from "../pages/Application";
import ApplicationDetails from "../pages/Application/ApplicationDetails";
import ApplicationSummary from "../pages/Application/ApplicationSummary";
import BIPUsers from "../pages/bip";
import Businesses from "../pages/businesses";
import BusinessDetail from "../pages/businesses/BusinessDetail";
import EditBusiness from "../pages/businesses/EditBusiness";
import CreateBusiness from "../pages/businesses/CreateBusiness";
import CreateBusinessProduct from "../pages/businesses/CreateBusinessProduct";
import CreateInvestment from "../pages/investment/CreateInvestment";
import Timelines from "../pages/Timeline";
import WalletToWallet from "../pages/WalletToWallet";
import RealEstate from "../pages/RealEstate";
import CRC from "../pages/CRC";
import HWSTickets from "../pages/HWSTickets";
import HWSDonations from "../pages/HWSDonations";
import Stocks from "../pages/Stocks";
import CoopTransactions from "../pages/CoopTransactions";
import StockDetail from "../pages/Stocks/StockDetail";
import CreateStock from "../pages/Stocks/CreateStock";
import EditStock from "../pages/Stocks/EditStock";
import Ipos from "../pages/Ipos";
import IpoDetail from "../pages/Ipos/IpoDetail";
import CreateIpo from "../pages/Ipos/CreateIpo";
import EditIpo from "../pages/Ipos/EditIpo";

export const publicRoutes = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "*",
    element: <Navigate to={"/"} />,
  },
]);

export const protectedRoutes = createBrowserRouter([
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/user-management",
    element: <UserManagement />,
  },
  {
    path: "/waitlist",
    element: <WaitList />,
  },
  {
    path: "/bip",
    element: <BIPUsers />,
  },
  {
    path: "/withdrawal-request",
    element: <WithdrawalRequest />,
  },
  {
    path: "/wallet-to-wallet",
    element: <WalletToWallet />,
  },
  {
    path: "/account-summary",
    element: <AccountSummary />,
  },
  {
    path: "/account-summary/:id",
    element: <AccountSummaryDetail />,
  },
  {
    path: "/user-management/:id",
    element: <UserManagementDetail />,
  },
  {
    path: "/user-management-business/:id",
    element: <BusinessUserManagementDetail />,
  },
  {
    path: "/businesses",
    element: <Businesses />,
  },
  {
    path: "/businesses/create",
    element: <CreateBusiness />,
  },
  {
    path: "/business/product/create",
    element: <CreateBusinessProduct />,
  },
  {
    path: "/business/product/edit/:id",
    element: <CreateBusinessProduct />,
  },
  {
    path: "/edit-business/:id",
    element: <EditBusiness />,
  },
  {
    path: "/businesses/:id",
    element: <BusinessDetail />,
  },
  {
    path: "/investment",
    element: <Investment />,
  },
  {
    path: "/real-estate",
    element: <RealEstate />,
  },
  {
    path: "/stocks",
    element: <Stocks />,
  },
  {
    path: "/stocks/create",
    element: <CreateStock />,
  },
  {
    path: "/stocks/edit/:id",
    element: <EditStock />,
  },
  {
    path: "/stocks/:id",
    element: <StockDetail />,
  },
  {
    path: "/ipos",
    element: <Ipos />,
  },
  {
    path: "/ipos/create",
    element: <CreateIpo />,
  },
  {
    path: "/ipos/edit/:id",
    element: <EditIpo />,
  },
  {
    path: "/ipos/:id",
    element: <IpoDetail />,
  },
  {
    path: "/crc",
    element: <CRC />,
  },
  {
    path: "/donations",
    element: <HWSDonations />,
  },
  {
    path: "/tickets",
    element: <HWSTickets />,
  },
  {
    path: "/timelines",
    element: <Timelines />,
  },
  {
    path: "/investment/create",
    element: <CreateInvestment />,
  },
  {
    path: "/campaign/create",
    element: <CreateCampaign />,
  },
  {
    path: "/edit-investment/:id",
    element: <EditInvestment />,
  },
  {
    path: "/investment/:id",
    element: <InvestmentDetail />,
  },
  {
    path: "/real-estate/:id",
    element: <RealEstateInvestmentDetail />,
  },
  {
    path: "/user-management/:id",
    element: <UserManagementDetail />,
  },
  {
    path: "/transaction",
    element: <Transaction />,
  },
  {
    path: "/coop-transactions",
    element: <CoopTransactions />,
  },
  {
    path: "/applications",
    element: <Application />,
  },
  {
    path: "/application-details/:id",
    element: <ApplicationDetails />,
  },
  {
    path: "/application-summary/:id",
    element: <ApplicationSummary />,
  },
  {
    path: "/previous-records",
    element: <PreviousRecords />,
  },
  {
    path: "/transaction/all",
    element: <AllTransaction />,
  },
  {
    path: "/transaction/:id",
    element: <TransactionDetail />,
  },
  {
    path: "/admin-email",
    element: <AdminEmail />,
  },
  {
    path: "/providus-report",
    element: <ProvidusReport />,
  },
  {
    path: "/providus-report/:id",
    element: <ProvidusReportDetail />,
  },

  {
    path: "/register",
    element: <Navigate to={"/"} />,
  },
  {
    path: "/Chart",
    element: <ChartOfAccount />,
  },

  {
    path: "*",
    element: <Navigate to={"/"} />,
  },
]);
